import { AccountInfo } from '../backend/features/types';

export function isInPricingPlan(flag: string, accountInfo: AccountInfo | undefined) {
    // console.log('FLG', accountInfo?.isInTrial, accountInfo?.flags?.indexOf(flag) !== -1);
    return accountInfo?.isInTrial || accountInfo?.flags?.indexOf(flag) !== -1;
}

export function isFlagOn(flag: string, accountInfo: AccountInfo | undefined) {
    return accountInfo?.flags?.indexOf(flag) !== -1;
}